import React from 'react'
import { achievements } from '../constants'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import CTA from '../components/CTA';

const Experience = () => {
  return (
    <section className='max-container'>
      <div className='py-16'>
        <h3 className='subhead-text'>
          Achievements
        </h3>
        <div className='mt-5 flex flex-col gap-3 text-slate-500'>
        <p className='font-semibold'>With a track record of participation and triumph, I've navigated diverse challenges, showcasing innovation and problem-solving. From ideation to execution, these victories represent a commitment to excellence and a passion for pushing boundaries in the ever-evolving tech landscape.</p>
      </div>
      <div className='mt-12 flex'>
          <VerticalTimeline>
            {achievements.map((achievement)=>(
              <VerticalTimelineElement
                key={achievement.issued_by}
                date={achievement.date}
                icon={
                  <div className='flex justify-center items-center w-full h-full'>
                    <img
                      src={achievement.icon}
                      alt={achievement.issued_by}
                      className='w-[60%] h-[60%] object-contain '
                    />
                  </div>
                }
                iconStyle={{background:achievement.iconBg}}
                contentStyle={{
                  borderBottom:'8px',
                  borderStyle:'solid',
                  borderBottomColor:achievement.iconBg,
                  boxShadow:'none',
                }}
              >
                <div>
                  <h3 className='text-black text-xl font-poppins font-semibold'>
                    {achievement.title}
                  </h3>
                  <p className='text-black-500 font-medium font-base' style={{margin:0}}>
                    {achievement.issued_by}
                  </p>
                </div>
                <img src={`${achievement.image}`} />
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
      </div>
      </div>
      <hr className='border-slate-200'/>
      <CTA/>
    </section>
  )
}

export default Experience;